import { render, staticRenderFns } from "./AppsMenuWindow.vue?vue&type=template&id=fbe89cf0&scoped=true"
import script from "./AppsMenuWindow.vue?vue&type=script&lang=js"
export * from "./AppsMenuWindow.vue?vue&type=script&lang=js"
import style0 from "./AppsMenuWindow.vue?vue&type=style&index=0&id=fbe89cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe89cf0",
  null
  
)

export default component.exports